import React from "react";
import { Loader2, Scissors } from "lucide-react";
import { PlanList } from "./StorageBits";
import { StaleDraftsBlock } from "./StaleDraftsBlock";

/** Trim plan + "Trim now" + last result + retention line. */
export function TrimColumn({ s }) {
  const { data, busy, result, pending } = s;
  const ret = data.retention;
  return (
    <div className="space-y-3">
      <div className="label-tiny">Trim plan</div>
      <PlanList plan={data.plan} />
      <button
        type="button" data-testid="storage-trim-btn" disabled={busy || !pending} onClick={s.trim}
        className="px-3 py-1.5 text-xs font-semibold bg-white text-zinc-950 hover:bg-zinc-200 disabled:opacity-40 rounded-sm flex items-center gap-1.5"
      >{busy ? <Loader2 size={12} className="animate-spin" /> : <Scissors size={12} />} {pending ? `Trim now (${pending.toLocaleString()} docs)` : "Nothing to trim"}</button>
      {result && (
        <div className="border border-emerald-900/60 bg-emerald-950/30 rounded-sm p-3">
          <div className="text-[11px] text-emerald-300 mono mb-1">Trimmed · {new Date(result.ran_at).toLocaleTimeString()}</div>
          <PlanList plan={result} done />
        </div>
      )}
      <div className="text-[11px] text-zinc-600 mono">retention: ingestion logs {ret.ingestion_log_days}d · skips {ret.rewrite_skip_days}d · jobs {ret.job_days}d · stuck rewriting {ret.stuck_rewriting_hours}h · drafts {ret.stale_draft_days ?? 14}d</div>
      <StaleDraftsBlock s={s} />
    </div>
  );
}
